import React from "react";
import classNames from "classnames";
import "./Container.scss";

interface Props {
  className?: string;

  /**
   * Tag to use for the main column element.
   */
  Element?: keyof React.ReactHTML;
}

/**
 * Component for [Bulma's Container](https://bulma.io/documentation/layout/container/). This component should be used as the root element for pages unless the design says otherwise.
 * 
 * N.B. Look at these stories in canvas mode - the component works best if it is the full-width of the screen.
 * 
 * @status development
 */
export const Container: React.FC<Props> = ({ children, className, Element = "div" }) => {
  return (
    <Element className={classNames("container", "tl-container", className)}>
      {children}
    </Element>
  )
}
